import { ArrowDownIcon, ArrowUpIcon } from "../../icons";
import { Button } from "../general/Button/Button";
import { Separator } from "../general/Separator/Separator";

interface Props {
    onNext(): void;
    onPrevious(): void;
}

export const ImporterPreviewNavigation: React.FC<Props> = ({
    onNext,
    onPrevious,
}) => (
    <>
        <Separator orientation="vertical" />
        <Button variant="link" icon onClick={onPrevious}>
            <ArrowUpIcon />
        </Button>
        <Button variant="link" icon onClick={onNext}>
            <ArrowDownIcon />
        </Button>
    </>
);
